/* ==========================================================================
   BUNDLE OFFER — Web Component (Black Hype)
   Wizard inline (sem drawer):
     Mode single → controls no slot "single"
     Mode bundle → wizard em steps: first → grid → detail → summary
   POST /cart/add.js com itens + line item properties quando bundle confirmado
   ========================================================================== */

(function () {
  if (window.customElements.get('bundle-offer')) return;

  class BundleOffer extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this.formId = this.dataset.formId;
      this.productId = this.dataset.productId;
      this.discountPct = parseInt(this.dataset.discountPercentage) || 15;

      // Bundle type: 'b1g2', 'b2g3', ou 'fixed_price_2_for_99'
      this.bundleType = this.dataset.bundleType || 'b2g3';
      
      // Ajuste de itemsTotais pegando do liquid, garantindo fallback correto
      this.itemsTotal = parseInt(this.dataset.itemsTotal) || (this.bundleType === 'b2g3' ? 3 : 2);
      this.itemsPaid = parseInt(this.dataset.itemsPaid) || (this.bundleType === 'b1g2' ? 1 : 2);

      this.selectedSecondVariantId = null;
      this.selectedSecondProperties = null;
      this.selectedSecondTitle = '';
      this.selectedSecondVariantTitle = '';
      this.selectedSecondOptionsText = '';
      this.selectedSecondImage = '';
      this.selectedSecondPrice = 0;

      // 3rd item (só para "Buy 2 Get 3")
      this.selectedThirdVariantId = null;
      this.selectedThirdProperties = null;
      this.selectedThirdTitle = '';
      this.selectedThirdVariantTitle = '';
      this.selectedThirdOptionsText = '';
      this.selectedThirdImage = '';
      this.selectedThirdPrice = 0;

      // Qual slot estamos escolhendo agora (2 ou 3)
      this.pickingItemSlot = 2;

      this.selectedMode = 'single';
      this.currentWizardStep = null;

      this.options = this.querySelectorAll('.bundle-option');

      this.setupOptionToggle();
      this.setupWizard();
      this.setupDetails();
      this.setupFormIntercept();
      this.setupCarousels();
      this.restoreSelection();
      this.relocateToProductForm();
      this.moveControlsToSlot(this.selectedMode);
    }

    // -------- Option toggle (1 Product / 2 Products) -------------------
    setupOptionToggle() {
      this.options.forEach((option) => {
        option.addEventListener('click', (e) => {
          if (
            e.target.closest('.bundle-option__choose-btn') ||
            e.target.closest('[data-embedded-controls]') ||
            e.target.closest('[data-wizard-step]') ||
            e.target.closest('.bundle-picker__item') ||
            e.target.closest('.bundle-picker__detail') ||
            e.target.closest('[data-wizard-goto]') ||
            e.target.closest('[data-detail-confirm]') ||
            e.target.closest('.bundle-picker__carousel-btn')
          ) return;

          const radio = option.querySelector('input[type="radio"][name^="bundle-choice-"]');
          if (!radio) return;
          radio.checked = true;
          this.options.forEach((o) => o.classList.remove('is-selected'));
          option.classList.add('is-selected');
          this.selectedMode = radio.value;
          this.clearFormError();
          this.updatePaymentButtonVisibility();
          this.moveControlsToSlot(this.selectedMode);
          this.syncWizardVisibility();
        });
      });
    }

    syncWizardVisibility() {
      if (this.selectedMode !== 'bundle') {
        this.showWizardStep(null);
        return;
      }
      
      // CRUCIAL: b1g2 E fixed_price_2_for_99 finalizam após o 2º item
      const isComplete = (this.bundleType === 'b1g2' || this.bundleType === 'fixed_price_2_for_99')
        ? !!this.selectedSecondVariantId
        : !!(this.selectedSecondVariantId && this.selectedThirdVariantId);
        
      if (isComplete) {
        this.showWizardStep('summary');
      } else {
        if (this.bundleType === 'b1g2' || this.bundleType === 'fixed_price_2_for_99') {
          this.pickingItemSlot = 2;
        } else {
          this.pickingItemSlot = this.selectedSecondVariantId ? 3 : 2;
        }
        this.showWizardStep('first');
      }
    }

    // -------- Wizard navigation ---------------------------------------
    setupWizard() {
      this.querySelectorAll('[data-wizard-goto]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const target = btn.dataset.wizardGoto;
          if (this.currentWizardStep === 'summary' && target === 'first') {
            this.pickingItemSlot = 2;
            this.resetDetailStep();
          }
          this.showWizardStep(target);
        });
      });

      this.querySelectorAll('.bundle-picker__item').forEach((item) => {
        item.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const id = item.dataset.productId;
          this.openDetail(id);
        });
      });
    }

    showWizardStep(step) {
      const steps = this.querySelectorAll('[data-wizard-step]');
      steps.forEach((el) => {
        el.hidden = el.dataset.wizardStep !== step;
      });
      this.currentWizardStep = step;

      this.updateWizardCopyForSlot(step);

      if (step === 'grid') {
        this.updateGridVisibility();
        setTimeout(() => this.updateAllCarouselsVisibility(), 50); 
      }

      if (step === 'detail') {
        const detailStep = this.querySelector('[data-wizard-step="detail"]');
        if (detailStep) detailStep.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
      if (step === 'summary') this.updateSummaryUI();
    }

    updateGridVisibility() {
      const grid2 = this.querySelector('[data-picker-grid][data-picker-slot="2"]');
      const grid3 = this.querySelector('[data-picker-grid][data-picker-slot="3"]');
      if (!grid2 && !grid3) return;

      if (this.pickingItemSlot === 3 && grid3) {
        if (grid2) grid2.hidden = true;
        grid3.hidden = false;
        if(grid2.closest('.bundle-picker__carousel-wrapper')) grid2.closest('.bundle-picker__carousel-wrapper').hidden = true;
        if(grid3.closest('.bundle-picker__carousel-wrapper')) grid3.closest('.bundle-picker__carousel-wrapper').hidden = false;
      } else {
        if (grid3) grid3.hidden = true;
        if (grid2) grid2.hidden = false;
        if(grid3 && grid3.closest('.bundle-picker__carousel-wrapper')) grid3.closest('.bundle-picker__carousel-wrapper').hidden = true;
        if(grid2 && grid2.closest('.bundle-picker__carousel-wrapper')) grid2.closest('.bundle-picker__carousel-wrapper').hidden = false;
      }
    }

    updateWizardCopyForSlot(step) {
      const progressEl = this.querySelector('[data-wizard-progress]');
      const gridTitleEl = this.querySelector('[data-wizard-grid-title]');
      const detailTitleEl = this.querySelector('[data-wizard-detail-title]');

      const slot = this.pickingItemSlot;
      const ordinal = slot === 3 ? '3rd' : '2nd';
      
      // CRUCIAL: b1g2 e fixed_price possuem 3 passos (first, picker, detail, done)
      const totalSteps = (this.bundleType === 'b1g2' || this.bundleType === 'fixed_price_2_for_99') ? 3 : 5;

      // Apenas adiciona "(FREE)" se for as regras exatas de gratuidade
      let isFreeSlot = false;
      if (this.bundleType === 'b1g2' && slot === 2) isFreeSlot = true;
      if (this.bundleType === 'b2g3' && slot === 3) isFreeSlot = true;
      const freeSuffix = isFreeSlot ? ' (FREE)' : '';

      if (step === 'first') {
        if (progressEl) progressEl.textContent = `Step 1 of ${totalSteps}`;
      } else if (step === 'grid') {
        let stepNum = 2;
        if (this.bundleType === 'b2g3' && slot === 3) stepNum = 4;
        if (progressEl) progressEl.textContent = `Step ${stepNum} of ${totalSteps}`;
        if (gridTitleEl) gridTitleEl.textContent = `Choose your ${ordinal} product${freeSuffix}`;
      } else if (step === 'detail') {
        let stepNum = 3;
        if (this.bundleType === 'b2g3' && slot === 3) stepNum = 5;
        if (progressEl) progressEl.textContent = `Step ${stepNum} of ${totalSteps}`;
        if (detailTitleEl) detailTitleEl.textContent = `Customize your ${ordinal} item${freeSuffix}`;
      }
    }

    openDetail(productId) {
      this.querySelectorAll('[data-detail-for]').forEach((d) => {
        d.hidden = d.dataset.detailFor !== String(productId);
      });
      this.showWizardStep('detail');
    }

    // -------- Setup dos detalhes --------------------------------------
    setupDetails() {
      this.querySelectorAll('[data-detail-for]').forEach((detailEl) => this.setupDetail(detailEl));

      const confirmBtns = this.querySelectorAll('[data-detail-confirm]');
      confirmBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const detailEl = this.querySelector('[data-detail-for]:not([hidden])');
          if (detailEl) this.confirmDetail(detailEl);
        });
      });
    }

    setupDetail(detailEl) {
      let variants = [];
      try {
        const script = detailEl.querySelector('[data-detail-variants]');
        variants = script ? JSON.parse(script.textContent) : [];
      } catch (e) { variants = []; }
      detailEl._variants = variants;

      const defaultVariant = variants.find((v) => v.available) || variants[0];
      detailEl._selectedVariant = defaultVariant;

      detailEl.querySelectorAll('[data-option-input]').forEach((input) => {
        input.addEventListener('change', () => this.onOptionChange(detailEl));
      });

      const nameInput = detailEl.querySelector('[data-detail-prop="Name"]');
      const nameCount = detailEl.querySelector('[data-name-count]');
      if (nameInput && nameCount) {
        nameInput.addEventListener('input', () => {
          nameCount.textContent = `${nameInput.value.length}/12`;
        });
      }

      this.onOptionChange(detailEl);
    }

    onOptionChange(detailEl) {
      const optionEls = detailEl.querySelectorAll('.bundle-picker__detail-option');
      const selectedValues = [];
      optionEls.forEach((optEl) => {
        const checked = optEl.querySelector('input[data-option-input]:checked');
        const val = checked ? checked.value : null;
        selectedValues.push(val);
        const label = optEl.querySelector('[data-option-selected]');
        if (label && val) label.textContent = val;
        optEl.querySelectorAll('.bundle-picker__detail-option-value').forEach((el) => {
          const input = el.querySelector('input');
          el.classList.toggle('is-selected', input && input.checked);
        });
      });

      const match = detailEl._variants.find((v) =>
        selectedValues.every((val, i) => val == null || v.options[i] === val)
      );
      if (match) {
        detailEl._selectedVariant = match;
        const priceEl = detailEl.querySelector('[data-detail-price]');
        if (priceEl) priceEl.textContent = this.formatMoney(match.price);
      }
      this.updateCustomizeVisibility(detailEl);
    }

    updateCustomizeVisibility(detailEl) {
      const customizeBox = detailEl.querySelector('[data-detail-customize]');
      if (!customizeBox) return;
      const variant = detailEl._selectedVariant;
      if (!variant) { customizeBox.hidden = true; return; }
      const optionNames = ['option1', 'option2', 'option3'];
      const matched = optionNames.some((key) => {
        const val = variant[key];
        return val && /customize/i.test(val) && !/not\s*customize/i.test(val);
      });
      customizeBox.hidden = !matched;
    }

    confirmDetail(detailEl) {
      const variant = detailEl._selectedVariant;
      if (!variant || !variant.available) {
        alert('This variant is unavailable. Please choose another option.');
        return;
      }

      const title = detailEl.querySelector('.bundle-picker__detail-title')?.textContent.trim() || '';
      const image = detailEl.querySelector('.bundle-picker__detail-image')?.src || '';

      const optionLabels = [];
      detailEl.querySelectorAll('.bundle-picker__detail-option').forEach((optEl) => {
        const name = optEl.dataset.optionName;
        const val = optEl.querySelector('[data-option-selected]')?.textContent?.trim();
        if (name && val) optionLabels.push(`${name}: ${val}`);
      });
      const optionsText = optionLabels.join(' • ');

      const props = {};
      const customizeBox = detailEl.querySelector('[data-detail-customize]');
      if (customizeBox && !customizeBox.hidden) {
        detailEl.querySelectorAll('[data-detail-prop]').forEach((input) => {
          const key = input.dataset.detailProp;
          const val = input.value.trim();
          if (val) props[key] = val;
        });
      }
      const properties = Object.keys(props).length ? props : null;

      const variantPrice = parseInt(variant.price) || 0;

      if (this.pickingItemSlot === 3) {
        this.selectedThirdVariantId = variant.id;
        this.selectedThirdVariantTitle = variant.title || '';
        this.selectedThirdTitle = title;
        this.selectedThirdImage = image;
        this.selectedThirdOptionsText = optionsText;
        this.selectedThirdProperties = properties;
        this.selectedThirdPrice = variantPrice;
        this.persistSelection();
        this.showWizardStep('summary');
      } else {
        this.selectedSecondVariantId = variant.id;
        this.selectedSecondVariantTitle = variant.title || '';
        this.selectedSecondTitle = title;
        this.selectedSecondImage = image;
        this.selectedSecondOptionsText = optionsText;
        this.selectedSecondProperties = properties;
        this.selectedSecondPrice = variantPrice;
        this.persistSelection();

        // CRUCIAL: b1g2 E fixed_price enviam o cliente direto para o sumário após o 2º item.
        if (this.bundleType === 'b1g2' || this.bundleType === 'fixed_price_2_for_99') {
          this.showWizardStep('summary');
        } else {
          this.pickingItemSlot = 3;
          this.resetDetailStep();
          this.showWizardStep('grid');
        }
      }
    }

    resetDetailStep() {
      this.querySelectorAll('[data-detail-for]').forEach((d) => { d.hidden = true; });
      this.querySelectorAll('[data-detail-prop]').forEach((input) => {
        input.value = '';
      });
      this.querySelectorAll('[data-name-count]').forEach((el) => { el.textContent = '0/12'; });
    }

    // -------- Summary -------------------------------------------------
    updateSummaryUI() {
      const firstDetails = this.buildFirstItemDetailsText();
      const firstDetailsEl = this.querySelector('[data-summary-first-details]');
      if (firstDetailsEl) firstDetailsEl.textContent = firstDetails;

      const secondImg = this.querySelector('[data-summary-second-image]');
      const secondTitle = this.querySelector('[data-summary-second-title]');
      const secondDetails = this.querySelector('[data-summary-second-details]');
      if (secondImg && this.selectedSecondImage) {
        secondImg.src = this.selectedSecondImage;
        secondImg.alt = this.selectedSecondTitle;
      }
      if (secondTitle) secondTitle.textContent = this.selectedSecondTitle;
      if (secondDetails) secondDetails.textContent = this.buildItemDetailsText('second');

      const thirdImg = this.querySelector('[data-summary-third-image]');
      const thirdTitle = this.querySelector('[data-summary-third-title]');
      const thirdDetails = this.querySelector('[data-summary-third-details]');
      if (thirdImg && this.selectedThirdImage) {
        thirdImg.src = this.selectedThirdImage;
        thirdImg.alt = this.selectedThirdTitle;
      }
      if (thirdTitle) thirdTitle.textContent = this.selectedThirdTitle;
      if (thirdDetails) thirdDetails.textContent = this.buildItemDetailsText('third');

      this.markCheapestAsFree();
    }

    markCheapestAsFree() {
      // CRUCIAL: Se for 2 por 99, ABORTA a lógica de colocar "FREE"
      if (this.bundleType === 'fixed_price_2_for_99') {
        const slotsToReset = ['first', 'second'];
        slotsToReset.forEach(key => {
          const item = this.querySelector(`[data-summary-slot="${key}"]`);
          const badge = this.querySelector(`[data-summary-${key}-badge]`);
          if (!item || !badge) return;
          item.classList.remove('bundle-wizard__summary-item--free');
          badge.classList.remove('bundle-wizard__summary-badge--free');
          // Garante que mostramos apenas 1st / 2nd item normais
          badge.textContent = key === 'first' ? '1st Item' : '2nd Item';
        });
        return;
      }

      // Lógica original para os outros bundles (b1g2, b2g3)
      const firstPrice = parseInt(this.dataset.variantPrice) || 0;
      const secondPrice = this.selectedSecondPrice || 0;

      const slots = [
        { key: 'first',  price: firstPrice,  label: '1st Item' },
        { key: 'second', price: secondPrice, label: '2nd Item' },
      ];
      if (this.itemsTotal >= 3) {
        slots.push({ key: 'third', price: this.selectedThirdPrice || 0, label: '3rd Item' });
      }

      let cheapest = slots[0];
      for (let i = 1; i < slots.length; i++) {
        if (slots[i].price <= cheapest.price) cheapest = slots[i];
      }

      slots.forEach((slot) => {
        const item = this.querySelector(`[data-summary-slot="${slot.key}"]`);
        const badge = this.querySelector(`[data-summary-${slot.key}-badge]`);
        if (!item || !badge) return;

        if (slot.key === cheapest.key) {
          item.classList.add('bundle-wizard__summary-item--free');
          badge.classList.add('bundle-wizard__summary-badge--free');
          badge.textContent = `${slot.label} — FREE`;
        } else {
          item.classList.remove('bundle-wizard__summary-item--free');
          badge.classList.remove('bundle-wizard__summary-badge--free');
          badge.textContent = slot.label;
        }
      });
    }

    buildFirstItemDetailsText() {
      const form = this.getForm();
      const parts = [];
      const picker = document.querySelector('variant-radios');
      if (picker) {
        picker.querySelectorAll('fieldset').forEach((fs) => {
          const legend = fs.querySelector('legend');
          const checked = fs.querySelector('input[type="radio"]:checked');
          if (legend && checked) {
            const optName = legend.textContent.trim().replace(/:$/, '');
            const optVal = checked.value;
            parts.push(`${optName}: ${optVal}`);
          }
        });
      }
      if (form) {
        try {
          const fd = new FormData(form);
          for (const [key, value] of fd.entries()) {
            const m = key.match(/^properties\[([^\]]+)\]$/);
            const v = String(value || '').trim();
            if (m && v) parts.push(`${m[1]}: ${v}`);
          }
        } catch (e) {}
      }
      return parts.join(' • ');
    }

    buildItemDetailsText(slot) {
      const capSlot = slot === 'third' ? 'Third' : 'Second';
      const optionsText = this[`selected${capSlot}OptionsText`];
      const variantTitle = this[`selected${capSlot}VariantTitle`];
      const properties = this[`selected${capSlot}Properties`];

      const parts = [];
      if (optionsText) {
        parts.push(optionsText);
      } else if (variantTitle && variantTitle !== 'Default Title') {
        parts.push(variantTitle);
      }
      if (properties) {
        Object.entries(properties).forEach(([k, v]) => {
          if (v) parts.push(`${k}: ${v}`);
        });
      }
      return parts.join(' • ');
    }

    // -------- Persistência --------------------------------------------
    persistSelection() {
      sessionStorage.setItem(
        `bundle-${this.productId}`,
        JSON.stringify({
          second: {
            variantId: this.selectedSecondVariantId,
            title: this.selectedSecondTitle,
            variantTitle: this.selectedSecondVariantTitle,
            optionsText: this.selectedSecondOptionsText,
            image: this.selectedSecondImage,
            properties: this.selectedSecondProperties,
            price: this.selectedSecondPrice,
          },
          third: {
            variantId: this.selectedThirdVariantId,
            title: this.selectedThirdTitle,
            variantTitle: this.selectedThirdVariantTitle,
            optionsText: this.selectedThirdOptionsText,
            image: this.selectedThirdImage,
            properties: this.selectedThirdProperties,
            price: this.selectedThirdPrice,
          },
        })
      );
    }

    restoreSelection() {
      try {
        const saved = sessionStorage.getItem(`bundle-${this.productId}`);
        if (!saved) return;
        const data = JSON.parse(saved);
        if (!data) return;

        const variantExists = (variantId) => {
          if (!variantId) return false;
          let found = false;
          this.querySelectorAll('[data-detail-for]').forEach((detailEl) => {
            try {
              const script = detailEl.querySelector('[data-detail-variants]');
              const variants = script ? JSON.parse(script.textContent) : [];
              if (variants.some((v) => String(v.id) === String(variantId))) found = true;
            } catch (e) {}
          });
          return found;
        };

        const sec = data.second || {};
        if (variantExists(sec.variantId)) {
          this.selectedSecondVariantId = sec.variantId;
          this.selectedSecondTitle = sec.title || '';
          this.selectedSecondVariantTitle = sec.variantTitle || '';
          this.selectedSecondOptionsText = sec.optionsText || '';
          this.selectedSecondImage = sec.image || '';
          this.selectedSecondProperties = sec.properties || null;
          this.selectedSecondPrice = sec.price || 0;
        }

        const thi = data.third || {};
        if (variantExists(thi.variantId)) {
          this.selectedThirdVariantId = thi.variantId;
          this.selectedThirdTitle = thi.title || '';
          this.selectedThirdVariantTitle = thi.variantTitle || '';
          this.selectedThirdOptionsText = thi.optionsText || '';
          this.selectedThirdImage = thi.image || '';
          this.selectedThirdProperties = thi.properties || null;
          this.selectedThirdPrice = thi.price || 0;
        }

        if (!this.selectedSecondVariantId && !this.selectedThirdVariantId) {
          sessionStorage.removeItem(`bundle-${this.productId}`);
        }
      } catch (e) {
        sessionStorage.removeItem(`bundle-${this.productId}`);
      }
    }

    // -------- Move Controles ------------------------------------------
    moveControlsToSlot(mode) {
      const slotAttr = mode === 'bundle' ? 'bundle-first' : 'single';
      const target = this.querySelector(`[data-embedded-controls][data-slot="${slotAttr}"]`);
      if (!target) return;

      const variantPicker = document.querySelector('variant-radios');
      if (variantPicker && variantPicker.parentElement !== target) {
        target.appendChild(variantPicker);
      }
      const customizeContainer = document.querySelector('[id^="customization-container-"]');
      if (customizeContainer && customizeContainer.parentElement !== target) {
        target.appendChild(customizeContainer);
      }
    }

    updatePaymentButtonVisibility() {
      const form = this.getForm();
      if (!form) return;
      const payBtn = form.querySelector('.shopify-payment-button');
      if (!payBtn) return;
      payBtn.style.display = this.selectedMode === 'bundle' ? 'none' : '';
    }

    formatMoney(cents) {
      const val = cents / 100;
      const locale = document.documentElement.lang || 'en-US';
      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
        }).format(val);
      } catch (e) {
        return '$' + val.toFixed(2);
      }
    }

    getForm() {
      return document.querySelector(`form[id="${this.formId}"][action*="/cart/add"]`)
        || document.querySelector(`form[is="product-form"][action*="/cart/add"]`);
    }

    showFormError(msg) {
      const form = this.getForm();
      if (!form) { alert(msg); return; }
      const errEl = form.querySelector('.product-form__error-message');
      if (errEl) { errEl.hidden = false; errEl.textContent = msg; }
      else alert(msg);
    }

    clearFormError() {
      const form = this.getForm();
      if (!form) return;
      const errEl = form.querySelector('.product-form__error-message');
      if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
    }

    relocateToProductForm() {
      const form = this.getForm();
      if (!form) return;
      const buttonsContainer = form.querySelector('.product-form__buttons');
      if (!buttonsContainer) return;

      document.querySelectorAll('bundle-offer').forEach((oldEl) => {
        if (oldEl === this) return;
        const variantPicker = oldEl.querySelector('variant-radios');
        const customizeContainer = oldEl.querySelector('[id^="customization-container-"]');
        if (variantPicker) document.body.appendChild(variantPicker);
        if (customizeContainer) document.body.appendChild(customizeContainer);
        oldEl.remove();
      });

      const originalWrapper = this.closest('.bundle-offer-section-wrapper');
      const errorMsg = buttonsContainer.querySelector('.product-form__error-message');
      const anchor = errorMsg || buttonsContainer.firstChild;
      buttonsContainer.insertBefore(this, anchor);
      if (originalWrapper) originalWrapper.style.display = 'none';
    }

    // -------- Lógica do Carrossel (Nativa da Classe) ------------------
    setupCarousels() {
      this._carouselResizeListener = this.updateAllCarouselsVisibility.bind(this);
      window.addEventListener('resize', this._carouselResizeListener);

      const carousels = this.querySelectorAll('.bundle-picker__carousel-wrapper');
      carousels.forEach(wrapper => {
        const carousel = wrapper.querySelector('.bundle-picker__grid--carousel');
        const prevBtn = wrapper.querySelector('.bundle-picker__carousel-btn--prev');
        const nextBtn = wrapper.querySelector('.bundle-picker__carousel-btn--next');

        if (!carousel || !prevBtn || !nextBtn) return;

        // Ouve o scroll para esconder/mostrar as setas se chegar no fim/início
        carousel.addEventListener('scroll', () => this.updateCarouselButtons(carousel, prevBtn, nextBtn));

        prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          // Rola de 2 em 2 itens (ou 1 se a tela for muito pequena)
          const scrollAmount = carousel.clientWidth * 0.7; 
          carousel.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        });

        nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const scrollAmount = carousel.clientWidth * 0.7;
          carousel.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        });
      });
    }

    updateAllCarouselsVisibility() {
      const carousels = this.querySelectorAll('.bundle-picker__carousel-wrapper:not([hidden])');
      carousels.forEach(wrapper => {
        const carousel = wrapper.querySelector('.bundle-picker__grid--carousel');
        const prevBtn = wrapper.querySelector('.bundle-picker__carousel-btn--prev');
        const nextBtn = wrapper.querySelector('.bundle-picker__carousel-btn--next');
        if (carousel && prevBtn && nextBtn) {
          this.updateCarouselButtons(carousel, prevBtn, nextBtn);
        }
      });
    }

    updateCarouselButtons(carousel, prevBtn, nextBtn) {
      // Se não precisa rolar (itens cabem na tela), esconde ambos
      if (carousel.scrollWidth <= carousel.clientWidth) {
        prevBtn.hidden = true;
        nextBtn.hidden = true;
        return;
      }
      // Chegou no começo
      prevBtn.hidden = carousel.scrollLeft <= 5; 
      // Chegou no fim (margem de 5px para bugs de arredondamento)
      nextBtn.hidden = Math.ceil(carousel.scrollLeft + carousel.clientWidth) >= (carousel.scrollWidth - 5);
    }

    // Para evitar memory leaks se o componente for removido do DOM
    disconnectedCallback() {
      if (this._carouselResizeListener) {
        window.removeEventListener('resize', this._carouselResizeListener);
      }
    }

    // -------- Intercept do submit --------------------------------------
    setupFormIntercept() {
      setTimeout(() => {
        const form = this.getForm();
        if (!form) return;

        if (form._bundleInterceptHandler) {
          form.removeEventListener('submit', form._bundleInterceptHandler, true);
        }

        const submitHandler = async (e) => {
            if (this.selectedMode !== 'bundle') return;

            if (this._submitting) {
              e.preventDefault();
              e.stopImmediatePropagation();
              return;
            }

            const needsThird = this.itemsTotal >= 3;
            if (!this.selectedSecondVariantId || (needsThird && !this.selectedThirdVariantId)) {
              e.preventDefault();
              e.stopImmediatePropagation();
              let missingSlot;
              if (!this.selectedSecondVariantId) {
                // Se for fixed price 99, não exibe "(FREE)" na mensagem de erro
                missingSlot = (this.bundleType === 'b1g2' || this.bundleType === 'fixed_price_2_for_99') ? '2nd' : '2nd';
                if (this.bundleType === 'b1g2') missingSlot = '2nd (FREE)';
              } else {
                missingSlot = '3rd (FREE)';
              }
              this.showFormError(`Please choose your ${missingSlot} product first.`);
              this.pickingItemSlot = !this.selectedSecondVariantId ? 2 : 3;
              this.showWizardStep('first');
              return;
            }

            e.preventDefault();
            e.stopImmediatePropagation();
            this.clearFormError();
            this._submitting = true;

            const primaryVariantId = form.querySelector('[name="id"]')?.value;
            if (!primaryVariantId) { this._submitting = false; return; }

            form.querySelectorAll('input[type="hidden"][name^="properties["]').forEach((el) => {
              if (/^properties\[(Nome|Número)\]$/.test(el.name)) el.remove();
            });
            const primaryProps = {};
            try {
              const fd = new FormData(form);
              for (const [key, value] of fd.entries()) {
                const match = key.match(/^properties\[([^\]]+)\]$/);
                const v = String(value || '').trim();
                if (match && v) primaryProps[match[1]] = v;
              }
            } catch (e) {}

            const submitBtns = form.querySelectorAll('[type="submit"]');
            submitBtns.forEach((btn) => {
              btn.setAttribute('aria-busy', 'true');
              btn.classList.add('loading');
            });

            try {
              let sectionsToBundle = [];
              document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', {
                bubbles: true,
                detail: { sections: sectionsToBundle },
              }));

              const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
              const qty = parseInt(form.querySelector('[name="quantity"]')?.value) || 1;
              const items = [
                { id: parseInt(primaryVariantId), quantity: qty },
                { id: parseInt(this.selectedSecondVariantId), quantity: qty },
              ];
              if (this.itemsTotal >= 3 && this.selectedThirdVariantId) {
                items.push({ id: parseInt(this.selectedThirdVariantId), quantity: qty });
              }
              if (Object.keys(primaryProps).length) items[0].properties = primaryProps;
              if (this.selectedSecondProperties) items[1].properties = this.selectedSecondProperties;
              if (items[2] && this.selectedThirdProperties) items[2].properties = this.selectedThirdProperties;

              const addBody = { items };
              if (sectionsToBundle.length) addBody.sections = sectionsToBundle.join(',');

              const response = await fetch(`${root}cart/add.js`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest',
                  Accept: 'application/javascript',
                },
                body: JSON.stringify(addBody),
              });

              const addRawText = await response.text();
              let responseJson;
              try {
                responseJson = JSON.parse(addRawText);
              } catch (parseErr) {
                this.showFormError('Cart service returned an unexpected response. Please refresh and try again.');
                return;
              }

              if (!response.ok) {
                this.showFormError(responseJson.description || responseJson.message || 'Error adding to cart.');
                return;
              }

              const cartResponse = await fetch(`${root}cart.js`);
              const cartRawText = await cartResponse.text();
              let cartJson;
              try {
                cartJson = JSON.parse(cartRawText);
              } catch (parseErr) {
                cartJson = { item_count: 0, sections: responseJson.sections || {} };
              }
              cartJson.sections = responseJson.sections || cartJson.sections || {};

              try {
                if (window.theme?.pubsub?.publish) {
                  window.theme.pubsub.publish(
                    window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate,
                    { cart: cartJson }
                  );
                }
              } catch (e) {}

              try {
                document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                  detail: { product: responseJson }
                }));
              } catch (e) {}

              try {
                const cartDrawer = document.querySelector('cart-drawer');
                if (cartDrawer && typeof cartDrawer.show === 'function') {
                  cartDrawer.show(submitBtns[0] || null);
                } else {
                  window.location.href = `${root}cart`;
                }
              } catch (e) {
                window.location.href = `${root}cart`;
              }
            } catch (err) {
              this.showFormError(err.message || 'Error adding to cart.');
            } finally {
              this._submitting = false;
              submitBtns.forEach((btn) => {
                btn.removeAttribute('aria-busy');
                btn.classList.remove('loading');
              });
            }
        };

        form._bundleInterceptHandler = submitHandler;
        form.addEventListener('submit', submitHandler, true);
      }, 100);
    }
  }

  window.customElements.define('bundle-offer', BundleOffer);
})();